import React from 'react'
import { StyleSheet, View } from 'react-native'
import { useTheme } from '@react-navigation/native'
import { Theme } from '@theme'
import { Skeleton } from './Skeleton'
import { Icon } from '../../atoms'

export const NoteItemSkeleton: React.FC = () => {
  const theme = useTheme()
  const styles = getStyle(theme)

  return (
    <View style={styles.container}>
      <View style={styles.content}>
        <Skeleton width="60%" height={16} borderRadius={4} style={styles.titleSkeleton} />
        <Skeleton width="80%" height={14} borderRadius={4} />
      </View>
      <Icon name="arrow" size={24} color={theme.colors.grey20} />
    </View>
  )
}

export const NoteItemSkeletonList: React.FC<{ count?: number }> = ({ count = 5 }) => {
  const theme = useTheme()
  const styles = getStyle(theme)

  return (
    <View style={styles.listContainer}>
      {Array.from({ length: count }).map((_, index) => (
        <View key={index}>
          <NoteItemSkeleton />
          {index < count - 1 && <View style={styles.separator} />}
        </View>
      ))}
    </View>
  )
}

const getStyle = (theme: Theme) =>
  StyleSheet.create({
    container: {
      flexDirection: 'row',
      alignItems: 'center',
      paddingHorizontal: theme.spacing.sm,
      paddingBottom: theme.spacing.lg,
      marginTop: theme.spacing.lg,
      borderBottomWidth: 1,
      borderBottomColor: theme.colors.grey20,
      gap: 10,
    },
    content: {
      flex: 1,
    },
    titleSkeleton: {
      marginBottom: 2,
    },
    listContainer: {
      padding: theme.spacing.lg,
    },
    separator: {
      height: 1,
      backgroundColor: theme.colors.grey,
      marginHorizontal: theme.spacing.md,
    },
  })

